import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import { connect } from "react-redux";
import { Ring } from "react-awesome-spinners";
import {
  FormButton,
  FormButtonsWrap,
  ErrorsBlock,
  LoaderWrap,
  FormHeading,
  IconWrap,
} from "../../";
import { unselectAllRecord, pushMessage } from "../../../actions";
import { deleteBEABidget, organizationBEABudget } from "../../../graphql";

const CancelRequest = (props) => {
  const {
    selectedBudgets,
    hideModal,
    unselectAllRecord,
    pushMessage,
  } = props;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitErrors, setSubmitErrors] = useState([]);

  const [deleteRequestBEABidget] = useMutation(deleteBEABidget);

  const handleQuit = (event) => {
    hideModal();
    unselectAllRecord("budgets");
  };

  const handleRequestDeleteSend = async (event) => {
    setIsSubmitting(true);
    setSubmitErrors([]);

    const results = await Promise.all(
      selectedBudgets.map(async ({ budget_id }) => {
        try {
          await deleteRequestBEABidget({
            variables: {
              budget_id: parseInt(budget_id),
            },
            awaitRefetchQueries: true,
            refetchQueries: [
              {
                query: organizationBEABudget,
                variables: {
                  where: { year: { eq: new Date().getFullYear().toString() } },
                },
              },
            ],
          });
          return { [budget_id]: false };
        } catch (e) {
          return { [budget_id]: e.message };
        }
      })
    );

    const errors = results.filter((r) =>
      Object.keys(r).find((r_id) => r[r_id])
    );
    if (!errors.length) {
      hideModal();
      unselectAllRecord("budgets");
      pushMessage({
        type: "success",
        message: "Request(s) successfully deleted.",
      });
    } else {
      setSubmitErrors(errors.map((e) => Object.values(e).shift()));
      setIsSubmitting(false);
    }
  };

  /* Release 3.1 - Starts */
  var selectedBEABudgetRequestIOrgs = selectedBudgets.map(function (el) {
    return el.organization_unit_name;
  });
  /* Release 3.1 - Ends */

  return (
    <div>
      <FormHeading>
        Are you sure you wish to delete request for {selectedBEABudgetRequestIOrgs.join()}?
      </FormHeading>
      {submitErrors.length > 0 &&
        submitErrors.map((err) => {
          return (
            <ErrorsBlock key={Math.random()}>
              <IconWrap>!</IconWrap>
              {err}
            </ErrorsBlock>
          );
        })}
      <FormButtonsWrap>
        {/* DEFECT No. 6 STARTS  */}
        <FormButton onClick={handleQuit}>Quit</FormButton>
        <FormButton
          primary
          disabled={isSubmitting}
          onClick={handleRequestDeleteSend}
        >
          Delete request(s)
        </FormButton>
        {/* DEFECT No. 6 ENDS  */}
        {isSubmitting && (
          <LoaderWrap>
            <Ring color={"#001235"} size="2" sizeUnit="rem" />
          </LoaderWrap>
        )}
      </FormButtonsWrap>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedBudgets: state.selectedBudgets,
    account: state.account,
  };
};

export default connect(mapStateToProps, { unselectAllRecord, pushMessage })(
  CancelRequest
);
